import styles from "../styles/Events.module.css";

const events = [
  {
    title: "Friday DJ Night",
    date: "Every Friday",
    time: "22:00 - Late",
    description:
      "Resident DJs, deep house, and signature cocktails all night long."
  },
  {
    title: "Live Music Sessions",
    date: "Saturdays",
    time: "20:30",
    description:
      "Local bands performing acoustic & lounge sets in a cozy atmosphere."
  },
  {
    title: "Cocktail Specials Night",
    date: "Wednesdays",
    time: "18:00 - 23:00",
    description:
      "Buy one get one on selected signature cocktails."
  }
];

function Events() {
  return (
    <section id="events" className={styles.events}>
      <div className={styles.container}>
        <span className={styles.subtitle}>WHAT'S ON</span>

        <h2>Events & Nights</h2>

        <p className={styles.description}>
          At KitchenBar, every week brings a new reason to come back.
        </p>

        <div className={styles.grid}>
          {events.map((event, index) => (
            <div className={styles.card} key={index}>
              <div className={styles.top}>
                <h3>{event.title}</h3>
                <span>{event.date}</span>
              </div>

              <div className={styles.time}>{event.time}</div>

              <p>{event.description}</p>

              <a href="#contact" className={styles.button}>
                Book Table
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Events;